var map = {
	"./logo1.png": "c26c",
	"./logo2.png": "fd4e",
	"./logo3.png": "eaf7",
	"./logo4.png": "d93a",
	"./logo5.png": "ed9c",
	"./logo6.png": "aef7",
	"./logo7.png": "f17d",
	"./logo8.png": "2732",
	"./logo9.png": "af0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e0f0";